import { reactive, ref } from "vue";

export function useBukaSelectModal() {
  const bukaSelectModalRef = ref()

  const bukaSelectModalParts = reactive({
    title: '部課の選択',
    button: ''
  })

  const openBukaSelectModal = () => {
    bukaSelectModalRef.value.open()
  }

  const closeBukaSelectModal = () => {
    bukaSelectModalRef.value.close()
  }

  return {
    bukaSelectModalRef,
    bukaSelectModalParts,
    openBukaSelectModal,
    closeBukaSelectModal,
  }
}
